export default "__VITE_ASSET__CFBybF35__"